import React from 'react';
import NotesIcon from '@mui/icons-material/Notes';
import { Container, RightContainer, Title, DropdownContainer } from './styled';

import {  useSelector } from 'react-redux';


const Criticidade = () => {
  const thisCard = useSelector((state) => state.card);
  const complexidade = thisCard.complexidade;
  const relevancia = thisCard.relevancia;

  const dadosComplexidade = [
		{ _id: '1', description: '1 - Sem Complexidade' },
		{ _id: '2', description: '2 - Pouco Complexo'},
		{ _id: '3', description: '3 - Complexo'},
		{ _id: '4', description: '4 - Muito Complexo'},
		{ _id: '5', description: '5 - Extremamente Complexo'},
	];

  const dadosRelevancia = [
    { _id: '1', description: '1 - Pouca Relevância' },
    { _id: '2', description: '2 - Baixa Relevância'},
    { _id: '3', description: '3 - Média Relevância'},
    { _id: '4', description: '4 - Alta Relevância'},
    { _id: '5', description: '5 - Extrema Relevância'},
  ];

  let criti = '0';
  if(relevancia !== undefined && complexidade !== undefined){

    const complexidadeObj = dadosComplexidade.find((item) => item.description === String(complexidade));
    const relevanciaObj = dadosRelevancia.find((item) => item.description === String(relevancia));

    if (complexidadeObj && relevanciaObj) {
      criti = Number(complexidadeObj._id) * Number(relevanciaObj._id);
    }
  
  }
	
return (
  <Container >    
    <NotesIcon fontSize='small' />
      <RightContainer>
        <Title>Criticidade</Title>
        <DropdownContainer>
        <Title>{criti}</Title>
				</DropdownContainer>
      </RightContainer>
  </Container>
  )
};

export default Criticidade;
